export enum EPropertyType {
  string = 1, // x="3"
  identifier = 2, // x={3} // ng x={{3}} [x]="3"
  event = 3, // <a onClick={(e) => {  }} //ng (click)="{{()=>{}}}"
  column = 4, // x={24} //ng xs="24"
  object = 7, // table column example [{'title':'Name','dataIndex':'name','key':'name'}] x={3}
  enum = 8, // Enum Json: [{enumKey: "apple", enumValue: "1"}]
  number = 9, // x={3} // ng x="3"
  boolean = 10, // x={true}//ng x="true"
  // stringArray = 11, //  x={['@', '#']}//ng [x]="['@', '#']"
  // numberArray = 12, //  x={[1, 2]}//ng [x]="[1, 2]"
  ngDataInput = 13, // [properties]="black"
  onlyAttributeName = 14, // x //ng x,
  angularDataBind = 15, // [(ngX)]
  image = 16, // base64,
  icon = 17, // Font
  colorPickerArray = 18,
  colorPicker = 19,
  dateTime = 20
}

export const ReactTypes: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 18, 19, 20, 21];
export const AngularTypes: any[] = [1, 3, 4, 7, 8, 9, 10, 13, 14, 15, 16, 17, 18, 19];
